var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Phone",
    d: "M143.8,18.762c-1.044-1.866-4.71-3.614-6.8-3.651s-2.024,2.763-2.021,2.769a13.417,13.417,0,0,1-5.357-3.493,13.393,13.393,0,0,1-3.492-5.356c.007,0,2.806.069,2.77-2.023s-1.786-5.756-3.653-6.8-5.526,2.054-5.224,5.836,2.656,8.448,6.075,11.867,8.086,5.775,11.867,6.076,6.879-3.357,5.836-5.225",
    transform: "translate(-120 -0.004)",
    fill: "#E65847"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIconSelected);
export default __webpack_public_path__ + "static/media/SupportIconSelected.e32ac1e59557b0370cf538e672eceb0e.svg";
export { ForwardRef as ReactComponent };